export const audienceSearchAttributes = {
  EMAIL: 'email',
  PHONE: 'phone',
  CUSTOM_ID: 'customId'
}